
import { Component, Vue } from "vue-property-decorator";
import { priceCheckService } from "@/services/api/priceCheck.service";
import { getModule } from "vuex-module-decorators";
import AuthModule from "@/store/modules/core/auth.module";
import store from "@/store";
import {
  PriceCheckItemTable,
  PriceCheckUpdate,
} from "@/models/entities/priceCheck/priceCheck.interface";

const authModule = getModule(AuthModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    MessageDialog,
  },
})
export default class PriceCheck extends Vue {
  // VARS
  private tableInsertData = {
    catalogues: {
      range: [
        { text: "Avus", value: { art_Categoria: "002", sourceID: 3 } },
        { text: "Fondmetal", value: { art_Categoria: "002", sourceID: 4 } },
        { text: "MAK", value: { art_Categoria: "002", sourceID: 2 } },
      ],
      selected: null,
      label: "Catalogo",
    },
    code: {
      value: "",
      label: "Codice prodotto",
    },
    expectedPrice: {
      value: null,
      label: "Prezzo atteso",
    },
    isValid: () => {
      return (
        this.tableInsertData.catalogues.selected &&
        this.tableInsertData.code.value &&
        this.tableInsertData.code.value.length > 0 &&
        this.tableInsertData.expectedPrice.value > 0
      );
    },
    clear: () => {
      this.tableInsertData.catalogues.selected = null;
      this.tableInsertData.code.value = "";
      this.tableInsertData.expectedPrice.value = null;
    },
  };

  private tablePriceCheck = {
    isLoading: true,
    set: [],
    headers: [
      { text: "Codice", value: "art_Codice" },
      { text: "Categoria", value: "art_categoria" },
      { text: "Catalogo", value: "sourceDescription" },
      { text: "Prezzo Atteso", value: "art_PrezzoAtteso" },
      { text: "Prezzo Catalogo", value: "netPrice" },
      {
        text: "Azioni",
        value: "actions",
        filterable: false,
        sortable: false,
        align: "center",
      },
    ],
  };

  private modalDelete = {
    isOpen: false,
    value: null,
    closeModal: () => {
      this.modalDelete.isOpen = false;
    },
  };

  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";
  private beforeCreate(): void {
    if (authModule.role != "0") {
      this.$router.push("/");
    }
  }

  mounted(): void {
    this.refreshTable();
  }

  // METHODS --- GET
  private refreshTable(): void {
    this.tablePriceCheck.isLoading = true;
    priceCheckService
      .getChecks()
      .then((res) => {
        // also add a variable to define if it's edited or not:
        this.tablePriceCheck.set = res.data.map((singleItem) => ({
          ...singleItem,
          art_PrezzoAttesoEdited: singleItem.art_PrezzoAtteso,
          art_PrezzoAttesoEditedDefault: singleItem.art_PrezzoAtteso,
          isUnderEdit: false,
        }));
        this.tablePriceCheck.isLoading = false;
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // METHODS --- INSERT
  private priceCheckInsert(): void {
    let itemToInsert: PriceCheckUpdate = {
      art_categoria: this.tableInsertData.catalogues.selected.art_Categoria,
      sourceID: this.tableInsertData.catalogues.selected.sourceID,
      art_Codice: this.tableInsertData.code.value,
      art_PrezzoAtteso: parseFloat(
        this.tableInsertData.expectedPrice.value + ""
      ),
    };
    // call to API
    priceCheckService
      .insertCheck(itemToInsert)
      .then(() => {
        // reload table
        this.refreshTable();
        // clear fields
        this.tableInsertData.clear();
        // show dialog for success
        this.dialogText = "Controllo inserito con successo!";
        this.messageDialogOpen = true;
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // METHODS --- EDIT
  private priceCheckEdit(item: PriceCheckItemTable) {
    // set to default prezzoAtteso value
    item.art_PrezzoAttesoEdited = item.art_PrezzoAttesoEditedDefault;
    item.isUnderEdit = true;
  }
  private priceCheckEditSubmit(item: PriceCheckItemTable) {
    // also update item value with
    let itemToPut = {
      art_Codice: item.art_Codice,
      art_PrezzoAtteso: item.art_PrezzoAttesoEdited,
    };
    // call to API
    priceCheckService
      .updateCheck(itemToPut)
      .then(() => {
        // reload table
        this.refreshTable();
        // show dialog for success
        this.dialogText = "Controllo modificato con successo!";
        this.messageDialogOpen = true;
      })
      .catch((e) => {
        console.warn(e);
      });
  }
  private priceCheckEditCancel(item: PriceCheckItemTable) {
    item.art_PrezzoAttesoEdited = item.art_PrezzoAttesoEditedDefault;
    item.isUnderEdit = false;
  }

  // METHODS --- DELETE
  private priceCheckDelete(item: PriceCheckItemTable) {
    this.modalDelete.value = {
      art_Codice: item.art_Codice,
      sourceID: item.sourceID,
    };
    this.modalDelete.isOpen = true;
  }
  private priceCheckDeleteSubmit() {
    priceCheckService
      .deleteCheck(this.modalDelete.value)
      .then(() => {
        // reload table
        this.refreshTable();
        // show dialog for success
        this.modalDelete.closeModal();
        this.dialogText = "Controllo rimosso con successo!";
        this.messageDialogOpen = true;
      })
      .catch((e) => {
        console.warn(e);
        this.modalDelete.closeModal();
      });
  }
}
